


// import { Doughnut } from "react-chartjs-2";
// import { BsGraphUpArrow } from "react-icons/bs";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend
// } from "chart.js";
// import { useTranslation } from "react-i18next";

// ChartJS.register(ArcElement, Tooltip, Legend);
// export default function MyDoughnutChart({ dataSource = [], title = "Chart" }) {
//   const { t } = useTranslation();
//   // Handle case when no data available
//   if (!dataSource || dataSource.length === 0) {
//     return (
//       <div className=" text-muted py-5">
//         <div>
//           <div className="flex justify-center  py-3">
//           <div className="rounded-circle border p-4">
//             <BsGraphUpArrow className="text-[50px] text-center text-red-400 " />
//           </div>
//         </div>
//         <div className="text-center">
//            {t("noDataAvailable")}
//         </div>
//         </div>
//       </div>
//     );
//   }

//   // Transform API data to chart structure
//   const labels = dataSource.map(item => item.name);
//   const values = dataSource.map(item => item.totalQuantity);

//   const data = {
//     labels,
//     datasets: [
//       {
//         label: title,
//         data: values,
//        backgroundColor: [
//          'rgba(240, 115, 115, 0.8)',
//         'rgba(91, 240, 171, 0.8)',
//         'rgba(84, 146, 222, 0.8)',
//         'rgba(209, 170, 73, 0.8)',
//         'rgba(180, 76, 212, 0.8)',
//         'rgba(168, 219, 83, 0.8)',

        
//       ],
//       borderColor: [
//         'rgba(240, 115, 115, 1)',
//            'rgba(91, 240, 171, 1)',  
       
//           'rgba(84, 146, 222, 1)',
//           'rgba(209, 170, 73, 1)',
//         'rgba(180, 76, 212, 1)',
//          'rgba(168, 219, 83, 1)',
        
     

//       ],
//       borderWidth: 1,
//         borderWidth: 2,
//         hoverOffset: 6
//       }
//     ]
//   };

//   const options = {
//      responsive: true,
//     maintainAspectRatio: false, // ✅ MUST
//     plugins: {
//       legend: {
//         position: "top"
        
//       },
//       title: {
//         display: true,
//         text: title
//       },
//       tooltip: {
//       backgroundColor: "rgba(0, 0, 0, 0.8)", 
//       titleColor: "#fff", // title text color
//       bodyColor: "#f0f0f0", // value text color
//       cornerRadius: 8,
//       padding: 14, // inner padding
//       titleFont: {
//         size: 15,
//         weight: "bold",
//         family: "Arial"
//       },
//       bodyFont: {
//         size: 13,
//         family: "Arial"
//       },
//       displayColors: true,
//         boxPadding: 8,
//       rtl: false,
//       usePointStyle: true,
//         callbacks: {
//            title: function (context) {
//             const item = dataSource[context[0].dataIndex];
//             if (item.branchName) {
//               return `${context[0].label} (${item.branchName})`;
//             }
//             return context[0].label;
//           },
//           label: function (context) {
//             return `${context.label}: ${context.formattedValue}`;
//           }
//         },

//       boxHeight: 10,
//       boxWidth: 10,
//       // Chart.js does not expose direct maxWidth option,
//       // so we use external tooltip style hook:
//       external: function (context) {
//         const tooltipEl = context.tooltip?.el;
//         if (tooltipEl) {
//           tooltipEl.style.whiteSpace = "nowrap"; // ✅ keep text on one line
//           tooltipEl.style.maxWidth = "none"; // allow full width
//         }
//       }
//     }
//   }
// };

//   return <Doughnut data={data} options={options} />;
// }



import { Doughnut } from "react-chartjs-2";
import { BsGraphUpArrow } from "react-icons/bs";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function MyDoughnutChart({ dataSource = [], title = "Chart" }) {
  const { t } = useTranslation();

  const [ready, setReady] = useState(false);

  // 🔥 small render delay fix (prevents blank chart issue)
  useEffect(() => {
    setReady(false);
    const timer = setTimeout(() => {
      setReady(true);
    }, 50);
    return () => clearTimeout(timer);
  }, [dataSource]);

  // ✅ CLEAN DATA (remove Unknown + 0 values)
  const cleanData = (dataSource || []).filter(
    item =>
      item &&
      item.name &&
      item.name.toLowerCase() !== "unknown" &&
      Number(item.totalQuantity) > 0
  );

  // 🚫 No Data UI
  if (!cleanData || cleanData.length === 0) {
    return (
      <div className="text-muted py-5">
        <div>
          <div className="flex justify-center py-3">
            <div className="rounded-circle border p-4">
              <BsGraphUpArrow className="text-[50px] text-center text-red-400" />
            </div>
          </div>
          <div className="text-center">
            {t("noDataAvailable")}
          </div>
        </div>
      </div>
    );
  }

  // ⏳ Wait for ready (prevents render glitch)
  if (!ready) return null;

  // ✅ SAFE LABELS + VALUES
  const labels = cleanData.map(item => item.name);
  const values = cleanData.map(item => Number(item.totalQuantity) || 0);

  const data = {
    labels,
    datasets: [
      {
        label: title,
        data: values,
        backgroundColor: [
          'rgba(240, 115, 115, 0.8)',
          'rgba(91, 240, 171, 0.8)',
          'rgba(84, 146, 222, 0.8)',
          'rgba(209, 170, 73, 0.8)',
          'rgba(180, 76, 212, 0.8)',
          'rgba(168, 219, 83, 0.8)',
        ],
        borderColor: [
          'rgba(240, 115, 115, 1)',
          'rgba(91, 240, 171, 1)',
          'rgba(84, 146, 222, 1)',
          'rgba(209, 170, 73, 1)',
          'rgba(180, 76, 212, 1)',
          'rgba(168, 219, 83, 1)',
        ],
        borderWidth: 2,
        hoverOffset: 6
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // ✅ MUST
    plugins: {
      legend: {
        position: "top"
      },
      title: {
        display: true,
        text: title
      },
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "#fff",
        bodyColor: "#f0f0f0",
        cornerRadius: 8,
        padding: 14,
        titleFont: {
          size: 15,
          weight: "bold",
          family: "Arial"
        },
        bodyFont: {
          size: 13,
          family: "Arial"
        },
        displayColors: true,
        boxPadding: 8,
        rtl: false,
        usePointStyle: true,
        callbacks: {
          title: function (context) {
            const item = cleanData[context[0].dataIndex];
            if (item.branchName) {
              return `${context[0].label} (${item.branchName})`;
            }
            return context[0].label;
          },
          label: function (context) {
            return `${context.label}: ${context.formattedValue}`;
          }
        },
        external: function (context) {
          const tooltipEl = context.tooltip?.el;
          if (tooltipEl) {
            tooltipEl.style.whiteSpace = "nowrap";
            tooltipEl.style.maxWidth = "none";
          }
        }
      }
    }
  };

  return (
    <Doughnut
      key={JSON.stringify(values)} // 🔥 force re-render (main fix)
      data={data}
      options={options}
    />
  );
}